import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=542d8058&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
import style0 from "./Join.vue?vue&type=style&index=0&id=542d8058&prod&scoped=true&lang=css"
import style1 from "./Join.vue?vue&type=style&index=1&id=542d8058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d8058",
  null
  
)

export default component.exports